import { render } from "./AppSwitcherDropdown.vue?vue&type=template&id=4fec2212&scoped=true"
import script from "./AppSwitcherDropdown.vue?vue&type=script&lang=js"
export * from "./AppSwitcherDropdown.vue?vue&type=script&lang=js"

import "./AppSwitcherDropdown.vue?vue&type=style&index=0&id=4fec2212&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fec2212"],['__file',"src/components/AppSwitcherDropdown/AppSwitcherDropdown.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4fec2212"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4fec2212', __exports__)) {
    api.reload('4fec2212', __exports__)
  }
  
  module.hot.accept("./AppSwitcherDropdown.vue?vue&type=template&id=4fec2212&scoped=true", () => {
    api.rerender('4fec2212', render)
  })

}


export default __exports__